import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import UnderConstruction from "../container/Blank/UnderConstruction";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Transportation = () => {
  const show = true;
  if (show) {
    return (
      <React.Fragment>
        <SEO title="Transportation | DMBD 2023" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="Transportation"
          content="For Participants"
          contentTwo="Transportation"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content">
            <h3>Sanya Phoenix International Airport</h3>
            <br />

            <p>
              <img
                src="./images/sanya/airport.jpg"
                width={650}
              // height={300}
              />

            </p>


            <br />
            <p>
              Sanya Phoenix International Airport is the main international airport serving Sanya, located in Fenghuang Village, Tianya District, Sanya City, Hainan Province, China. It serves as a crucial transportation hub in southern China, connecting the region to various domestic and international destinations. The airport is situated approximately 20 kilometers from the city center.
              <br />
              Sanya Phoenix International Airport offers a range of facilities and services to accommodate the needs of travelers. The airport has multiple terminals and serves numerous airlines, providing both domestic and international flights. It operates routes to major cities such as Beijing, Shanghai, Guangzhou, Hong Kong, Macau, Seoul, Bangkok, and more.
              <br />
              <p>
                <img
                  src="./images/sanya/airport2.png"
                  width={650}
                // height={300}
                />
              </p>
              The airport features a variety of amenities to enhance the passenger experience. Travelers can find a selection of shops, including duty-free stores, where they can purchase souvenirs, local products, and other goods. There are also restaurants and eateries offering a range of cuisine, from local Hainan dishes to international fare.
              <br />
              For passengers looking for additional comfort and convenience, Sanya Phoenix International Airport provides VIP lounges, business centers, and premium services. These facilities offer a quiet and relaxing environment for travelers to work, rest, or freshen up before or after their flights.
            </p>

            <p>
              For more information, please visit{" "}
              <a href="https://www.sanyaairport.com/autoweb/autoweb/syindex.html">Sanya Phoenix International Airport </a>
            </p>

            <p>&nbsp;</p>
            <h3>Sanya Railway Station</h3>
            <br />
            <img
              src="./images/sanya/trainstation.jpg"
              width={650}
            />
            <p>
              <br />
              Sanya Railway Station is a major transportation hub in Sanya, Hainan Province, China. Here`&apos;s an introduction to Sanya Railway Station:
              <br />
              Location: Sanya Railway Station is located on Fenghuang Road in Sanya city, approximately 10 kilometers from the city center. It is easily accessible by various modes of transportation.
              <br />
              <p>
                <img
                  src="./images/sanya/trainstation2.jpg"
                  width={650}
                />
              </p>
              Train Services: Sanya Railway Station offers train services connecting to major cities across China. Currently, it operates direct trains to destinations such as Beijing, Shanghai, Guangzhou, Shenzhen, Changsha, Chengdu, and Wuhan. The station also provides overnight high-speed train services, allowing passengers to travel conveniently during the night.
              <br />
              Station Facilities: Sanya Railway Station features modern station buildings and facilities to cater to the needs of passengers. It includes waiting rooms, ticketing halls, automated ticket machines, luggage storage facilities, and information desks. The station is designed to provide a comfortable and convenient experience for travelers.
              <br />
              Transportation Options: The station is well-connected to the surrounding areas and offers various transportation options for passengers. Taxis, buses, and other forms of local transportation are readily available, allowing travelers to reach their desired destinations in Sanya or nearby attractions.
            </p>



            {/* <p>
              From Qingdao Railway Station -&gt; Subway line 3 -&gt; May Fourth
              Square Station -&gt; Subway line 2 -&gt; Miaoling Road Station
              -&gt; Qingdao Blue Horizon Hotel Laoshan
            </p>

            <p>&nbsp;</p>
            <h3>To Ocean University Station</h3>
            <p>
              <img
                src="http://39.98.207.139:8080/icsi2021/wp-content/uploads/transport.jpg"
                width={400}
              />
            </p>
            <p>
              From Qingdao International Airport -&gt; 701 Busline Qingdao
              International Airport Station -&gt; Qingdao Car East Station -&gt;
              Subway line 2, Liaoyang East Road Station -&gt; Miaoling Road
              Station -&gt; Subway line 11 , Miaoling Road Station -&gt; Ocean
              University Station
            </p>
            <p>
              Travel time from the airport to Ocean University of China is one
              and a half hours. Airport Line 1 (bus 701) runs every hour from
              the airport to the East Bus Station and tickets can be purchased
              at the ticket counter in the bus for 20RMB in cash or by using the
              Qindao Pass card on the bus, then transfer to Metro Line 2 and
              change to Metro Line 11 in the station to reach Ocean University
              Station and tickets can be purchased at the ticket machine in the
              Metro station for 4RMB.
            </p> */}
          </div>
        </EmptyTwo>
        {/* <AboutFive />
				  <TestimonialContainer classOption="bg-primary-blue" />
				  <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
  else {
    return (
      <React.Fragment>
        <SEO title="Transportation | DMBD 2023" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="Transportation"
          content="For Participants"
          contentTwo="Transportation"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <UnderConstruction />
        </EmptyTwo>
        {/* <AboutFive />
				  <TestimonialContainer classOption="bg-primary-blue" />
				  <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
};

export default Transportation;
